import { Injectable } from '@angular/core';
import { HostReniec, HostSunat, HostInfobras, HostBPM, HostBPM2, wcfClaveToken, HttpHeaderToken} from 'src/app/general/variables';
import { HttpClient } from '@angular/common/http';
import { EventoInfobra } from 'src/app/models/EventoInfobra';
import { EjecucionInfobra } from 'src/app/models/EjecucionInfobra';
import { EmpresaSunat } from 'src/app/models/EmpresaSunat';
import { PlantillaDocumento } from 'src/app/models/PlantillaDocumento';
import { PDRespuesta } from 'src/app/models/PDRespuesta';
import { PersonaReniec } from 'src/app/models/PersonaReniec';
import { CorreoBpm } from 'src/app/models/CorreoBpm';
import { EstadoRequest } from 'src/app/models/EstadoRequest';
import { MailDetalle } from 'src/app/models/MailDetalle';
import { catchError } from 'rxjs/operators';
import { errorHandler } from 'src/app/general/Funciones';
import { TokenRequest } from 'src/app/models/TokenRequest';

@Injectable({
  providedIn: 'root'
})
export class ExternosService {


  url: String = `${HostReniec}`;
  urlSunat: String = `${HostSunat}`;
  urlInfobras: String = `${HostInfobras}`;
  urlBPM: String = `${HostBPM}`;
  urlBPM2: String = `${HostBPM2}`;


  constructor(protected http: HttpClient) { }

  obtenerPersonaXDniReniec(dni: string) {

    console.clear();

    return this.http.get<PersonaReniec>(`${this.url}/Persona/listarDocument/${dni}`, HttpHeaderToken())
    .pipe(catchError(errorHandler));


  }

  obtenerEmpresaXRUC(ruc: string) {

    // console.log("===`${this.urlSunat}/Ruc/listarRuc/${ruc}`",`${this.urlSunat}/Ruc/listarRuc/${ruc}`);

    return this.http.get<EmpresaSunat>(`${this.urlSunat}/Ruc/listarRuc/${ruc}`, HttpHeaderToken())
    .pipe(catchError(errorHandler));

  }

  obtenerEmpresaXRazonSocial(razonSocial: string) {
    return this.http.get<EmpresaSunat>(`${this.urlSunat}/Ruc/listarRazonSocial/${razonSocial}`, HttpHeaderToken());
  }

  buscarEmpresaXRazonSocial(razonSocial: string) {

    console.clear();

    return this.http.get<EmpresaSunat[]>(`${this.urlSunat}/Ruc/buscarRazonSocial/${razonSocial}`, HttpHeaderToken())
    .pipe(catchError(errorHandler));

  }

  generarDocumento(plantilla: PlantillaDocumento) {
    return this.http.post<PDRespuesta>(`${this.urlBPM}/doc/generarDocumento`, plantilla, HttpHeaderToken());
  }

  registrarDatosCorreo(correoBpm: CorreoBpm) {
    return this.http.post<CorreoBpm>(`${this.urlBPM2}/BPM/registrarDatosCorreo`, correoBpm, HttpHeaderToken());
  }

  listarNotifBandeja(mailDetalle: MailDetalle) {

    // console.log("====mailDetalle");
    // console.log(JSON.stringify(mailDetalle));

    return this.http.post<MailDetalle[]>(`${this.urlBPM2}/BPM/listarNotifBandeja`, mailDetalle, HttpHeaderToken());
  }

  actualizarNotifBandeja(mailDetalle: MailDetalle) {

    // console.log("====mailDetalle actualizarNotifBandeja");
    // console.log(mailDetalle);

    return this.http.post<MailDetalle[]>(`${this.urlBPM2}/BPM/actualizarNotifBandeja`, mailDetalle, HttpHeaderToken());
  }

  obtenerRepresentanteLegal(ruc: string) {
    return this.http.get<any>(`${this.urlSunat}/Ruc/listarRepresentanteLegal/${ruc}`, HttpHeaderToken());
  }

  listarMacroProceso(idTipoSistema: number) {
    return this.http.get<any>(`${this.urlBPM2}/lista/MacroProceso/${idTipoSistema}`, HttpHeaderToken());
  }

  actualizarEstados(estadoRequest: EstadoRequest) {
    return this.http.post<any>(`${this.urlBPM2}/utilSAD/actualizarEstados`, estadoRequest, HttpHeaderToken());
  }

  obtenerToken() {

    let tokenRequest: TokenRequest;

    tokenRequest = new TokenRequest();

    tokenRequest.token = wcfClaveToken;

    return this.http.post<TokenRequest>(`${this.urlBPM2}/utilSAD/obtenerToken`, tokenRequest, HttpHeaderToken());
  }


}
